<div class="empty-state">
  <div class="empty-icon" aria-hidden="true">
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 7h16M4 12h16M4 17h10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    </svg>
  </div>
  <h4>{{ title }}</h4>
  <p *ngIf="message">{{ message }}</p>
</div>
